import { FC } from 'react';
import { TableData } from '@/components/Table/types';
import { DataTableValue } from 'primereact/datatable';

import { Table } from '@/components';
import { getTableColumns, tableFilters } from './getServicetableColumns';

export interface Viaje {
  viaje: string;
  eta: string;
  apertura: string;
  cierre: string;
  servicio: string;
}

type ServiceTableProps = {
  data: Viaje[];
  isLoading: boolean;
  handleSelectionChange?: (e: { value: unknown }) => void;
  selectedItems?: unknown[];
};

const ServiceTable: FC<ServiceTableProps> = ({
  data,
  isLoading,
  handleSelectionChange,
  selectedItems,
}) => {
  const tableColumns = getTableColumns();

  return (
    <Table
      columns={tableColumns}
      data={data as unknown as TableData}
      isLoading={isLoading}
      paginator
      filterDisplay="menu"
      className="mt-4"
      style={{ flexBasis: '100%', display: 'flex' }}
      onSelectionChange={handleSelectionChange}
      selectedItems={selectedItems as DataTableValue[]}
      selectionId="codigo"
      filters={tableFilters}
    />
  );
};

export default ServiceTable;
